/// <amd-module name="Artifacts/Nuget/commands/PermanentDelete" />

import { NugetActions } from "Artifacts/Nuget/redux";
import { getPermanentDeleteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createPermanentDeleteCommand = getPermanentDeleteCommandCreator(
  NugetActions.permanentDelete,
);
